import React, {useEffect} from "react";
import {useDispatch, useSelector} from 'react-redux'
import {useWidget} from 'util/widget'
import { fetchInstructorData } from 'store/actions/widgetActions';
import Card from 'react-bootstrap/Card';
import PreviewImage from 'components/PreviewImage'
import * as moment from 'moment-timezone'
import {Link, useLocation} from 'util/router'

function ChallengeCard(props) {

    const location = useLocation()

    const timeText = () => {
        
        if (props.startDate && props.endDate) {

            return `${moment(props.startDate * 1000).format('MMM Do YYYY')} - ${moment(props.endDate * 1000).format('MMM Do YYYY')}`
        }

        return ""
    }


    return (
        <Card key={props.platformID} border='transparent' className='text-left p-0' style ={{width: '100%'}}>
            <Card.Body className='p-0'>
                
                <div className="row">
                    <div className="col-sm-12 col-md-4 mb-2">
                        <PreviewImage imageUrl={props.images ? props.images[0] : null} />    
                    </div>
                    <div className="col-sm-12 col-md-8 mb-2">
                        <div className="d-flex flex-column justify-content-between h-100">
                            <div>
                                <h3>{props.name || props.class_name}</h3>
                                {props.frequency !== 'subscription' && (
                                    <h6 className="m-0 p-0 mb-2">
                                        {timeText()}
                                    </h6>
                                )}
                                <h6>{props.datetime}</h6>
                                <Card.Text className="m-0 p-0 mb-2">
                                    {props.location}
                                </Card.Text>
                            </div>
                            <Link to={`${location.pathname}/` + props.id} className="btn btn-primary primaryColor" style={{"whiteSpace": "nowrap", "width": "120px"}}>View</Link>
                        </div>
                        
                    </div>
                </div>
            </Card.Body>
            {props.showDivider && (
                <hr />
            )}
        </Card>
    )
}

function ChallengesPage(props) {

    const widget = useWidget()
    const dispatch = useDispatch();
    React.useEffect(() => {
        // console.log("useWidget: ", widget)
        if (widget && widget.widgetName) {
            dispatch(fetchInstructorData(widget.widgetName, "offerings"));
        }
    }, [dispatch, widget.widgetName])

    let offerings = useSelector(state => state.widget.offerings.filter(val => {
        return val.type === 'challenge'
    }).sort((a,b) => {
        if (a.startDate && b.startDate) {
            return a.startDate - b.startDate 
        }
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
    }))

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }

    useEffect(() => {
        sendPostMessage()
    }, [offerings])

    return (<>

        {offerings.map(val => {
            return (
            <div key={val.id}>
                <ChallengeCard
                {...val}
                />
            </div>
            )
        })}
        
    </>
    )
}

export default ChallengesPage;
